import { isObject } from './typeGuards';

const isSignificantValue = (value: unknown): boolean => {
    if (value === null || value === undefined || value === '') return false;
    if (Array.isArray(value) && value.length === 0) return false;
    return true;
};

export const flattenObjectPaths = (
    obj: Record<string, unknown>,
    parentPath = '',
    ignoredKeys: string[] = ['source', 'id'],
): Record<string, unknown> => {
    return Object.entries(obj).reduce(
        (acc, [key, value]) => {
            if (!parentPath && ignoredKeys.includes(key)) return acc;
            if (!isSignificantValue(value)) return acc;

            const currentPath = parentPath ? `${parentPath}.${key}` : key;

            if (isObject(value)) {
                const nested = flattenObjectPaths(
                    value as Record<string, unknown>,
                    currentPath,
                    ignoredKeys,
                );

                if (Object.keys(nested).length > 0) {
                    Object.assign(acc, nested);
                }
            } else {
                acc[currentPath] = value;
            }

            return acc;
        },
        {} as Record<string, unknown>,
    );
};
